export default {
  name: 'GcLoader',
  data() {
    return {
      className: 'gc__loader',
    };
  },
  computed: {
    dotClassName() {
      return `${this.className}__dot`;
    },
    dotTypeClassName() {
      if (!this.type.length) return '';
      return `${this.className}__dot--${this.type}`;
    },
  },
  props: {
    type: {
      type: String,
      default: 'default',
    },
    styleObject: {
      type: Object,
      default: null,
    },
  },
};
